import Vue from 'vue';
import { isEmpty } from '@touchstone/touchstone-assets';
import { format } from 'date-fns';

const dateStringToUTC = (date) => {
    if (isEmpty(date)) return null;
    const dt = new Date(date);
    return new Date(dt.valueOf() + dt.getTimezoneOffset() * 60000);
};

Vue.filter('date_format', (value, convert) => {
    return isEmpty(value) ? 'N/A' : format(convert ? dateStringToUTC(value) : new Date(value), 'MM/dd/yyyy');
});
